<template>
  <v-flex v-if="declinedPayment" d-flex xs12 sm6 md4 lg3 xl3>
    <CreditCardDialog v-if="showUpdateCcDialog" v-model="showUpdateCcDialog" />
    <v-card xs4 color="white" class="card-border text-xs-left">
      <v-system-bar height="45" window color="red">
        <h2 class="card-header-text">Payment Declined</h2>
        <v-spacer />
      </v-system-bar>

      <div class="card-body">
        <!-- payment info              -->
        <div class="txt-bold">{{ declinedPayment.date }}</div>
        <div class="declined-payment-price">${{ declinedPayment.amount }} owed</div>
        <div class="pt-1">
          Your account will be placed on hold unless payment is received by {{ declinedPayment.pause_date }}
        </div>
        <div class="text-xs-center pt-4">
          <button class="button-blue" @click="showConfirmationDialog">
            Pay Now
          </button>
        </div>
      </div>
    </v-card>

    <v-snackbar
        v-model="snackbar.error"
        color="error"
        :multi-line="true"
        :timeout="snackbar.timeout" >
      {{ snackbar.errorMessage }}
    </v-snackbar>
    <v-snackbar
        v-model="snackbar.success"
        color="success"
        :multi-line="true"
        :timeout="snackbar.timeout" >
      {{ snackbar.successMessage }}
    </v-snackbar>

    <LoadingDialog v-model="showLoadingDialog" />
    <v-dialog v-if="declinedPayment" v-model="showPayDialog" max-width="400px">
      <v-card class="pa-3">
        <v-card-title class="pa-0">
          <h2>Make Payment</h2>
          <v-spacer />
          <v-btn flat icon color="itoviGrayMid" @click="showConfirmationDialog"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text v-if="ccInfo" class="pt-0 pl-3 pr-3">
          <div class="pb-4 text-sm-center">
            Your card ending in
            <b>{{ ccInfo.last_four }}</b>
            will be charged
            <b>${{ formatPrice(declinedPayment.amount) }}.</b>
            <span class="txt-button-blue txt-bold" @click="openCcDialog()">
                Update Card
              </span>
          </div>
          <div class="text-xs-center">
            <button  class="button-blue" @click="sendPayment">Pay ${{ formatPrice(declinedPayment.amount) }} now</button>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
  import api from "../../services/api_endpoints";
  import store from "@/store";
  import subscribeToStore from "@/mixins/subscribeToStore";
  import LoadingDialog from "../LoadingDialog"
  import CreditCardDialog from "./paymentInformationCard/CreditCardDialog";

  export default {
    components: {
      CreditCardDialog,
      LoadingDialog
    },
    data: ()=> ({
      declinedPayment: store.declinedPayment,
      ccInfo: store.ccInfo,
      showPayDialog: false,
      showLoadingDialog: false,
      showUpdateCcDialog: false,
      snackbar: {
        success: false,
        error: false,
        timeout: 2500,
        errorMessage: "An unknown error occurred",
        successMessage: "Payment submitted successfully"
      }
    }),
    props: {
      onLoaded: Function,
    },
    mixins: [subscribeToStore],
    created(){
      this.fetchDeclinedPayment()
    },
    mounted() {
      this.subscribeToStore(['declinedPayment', 'ccInfo', 'showPayDialog']);
    },
    methods: {
      formatPrice(value) {
        let val = (value/1).toFixed(2)
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      isFunction(functionToCheck) {
        return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
      },
      async fetchDeclinedPayment() {
        await api.getDeclinedPayment();
        if (this.isFunction(this.onLoaded)) this.onLoaded()
      },
      showConfirmationDialog() {
        this.$store.commit('setShowPayDialog', !this.showPayDialog);
      },
      async sendPayment() {
        this.showLoadingDialog = true
        let response = await api.payPastDueBill();

        if (response.success) {
          this.showPayDialog = false
          this.snackbar.success = true
          // it succeeded, fetch the declined payment again
          await this.fetchDeclinedPayment()
        } else {
          // the payment failed
          if (response.errorMessage !== '') this.snackbar.errorMessage = response.errorMessage
          this.snackbar.error = true
          this.showLoadingDialog = false
        }

        this.showLoadingDialog = false

      },
      openCcDialog() {
        this.$store.commit('setShowUpdateCcDialog',true)
      }
    },
  }
</script>
